const initialState = {
    modalDatabase: false,
    modalImportDatabase:false,
    modalSchema: false,
    modalTable: false,
}

const databaseReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'MODAL_DATABASE':
            return { ...state, modalDatabase: action.payload }
        case 'MODAL_IMPORT_DATABASE':
            return { ...state, modalImportDatabase: action.payload }
        case 'MODAL_SCHEMA':
            return { ...state, modalSchema: action.payload }
        case 'MODAL_TABLE':
            return { ...state, modalTable: action.payload }
        default:
            return state
    }
}

export default databaseReducer;